(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deed-method-journey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateCounter(counter) {
      if (!counter || counter.dataset.counted === 'true') return;
      counter.dataset.counted = 'true';
      const target = Number(counter.dataset.target || 0);
      const duration = 1200;
      const start = performance.now();

      function update(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = Math.round(target * eased).toLocaleString('en-US');
        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
    }

    document.querySelectorAll('[data-deed-journey]').forEach((section) => {
      const stages = section.querySelectorAll('[data-deed-stage]');

      if (reduceMotion || !('IntersectionObserver' in window)) {
        stages.forEach((stage) => {
          stage.classList.add('is-visible');
          const counter = stage.querySelector('[data-deed-counter]');
          if (counter) counter.textContent = Number(counter.dataset.target || 0).toLocaleString('en-US');
        });
        return;
      }

      const observer = new IntersectionObserver((entries, activeObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          animateCounter(entry.target.querySelector('[data-deed-counter]'));
          activeObserver.unobserve(entry.target);
        });
      }, { threshold: 0.26 });

      stages.forEach((stage) => observer.observe(stage));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deed-store-v3-home"] && !Shopify.designMode) return;
  try {
    
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.deed-story').forEach((root) => {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const revealItems = root.querySelectorAll('.dss-reveal');
    const timeSection = root.querySelector('[data-story-time]');
    const number = root.querySelector('[data-story-number]');
    const unit = root.querySelector('[data-story-unit]');
    let timePlayed = false;
    const playTime = () => {
      if (timePlayed || !number || !unit) return;
      timePlayed = true;
      const labels = [timeSection.dataset.storyDays, timeSection.dataset.storyWeeks, timeSection.dataset.storyHours];
      [['90', labels[0]], ['13', labels[1]], ['2,184', labels[2]]].forEach(([value, label], index) => window.setTimeout(() => { number.textContent = value; unit.textContent = label; }, index * 1150));
    };
    if (prefersReducedMotion || !('IntersectionObserver' in window)) { revealItems.forEach((item) => item.classList.add('is-visible')); return; }
    root.dataset.motion = 'ready';
    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => { if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); if (entry.target === timeSection) playTime(); activeObserver.unobserve(entry.target); });
    }, { threshold: 0.18 });
    revealItems.forEach((item) => observer.observe(item));
  });
  document.querySelectorAll('[data-journal-viewer]').forEach((viewer) => {
    if (viewer.dataset.ready) return;
    viewer.dataset.ready = 'true';
    const pages = Array.from(viewer.querySelectorAll('[data-journal-page]'));
    const previous = viewer.querySelector('[data-journal-prev]');
    const next = viewer.querySelector('[data-journal-next]');
    const count = viewer.querySelector('[data-journal-count]');
    let index = 0;
    let isTurning = false;
    const updateCount = () => {
      if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(pages.length).padStart(2, '0')}`;
    };
    const showPage = (nextIndex, direction) => {
      if (isTurning || !pages.length) return;
      const targetIndex = (nextIndex + pages.length) % pages.length;
      if (targetIndex === index) return;
      if (prefersReducedMotion) {
        pages.forEach((page, pageIndex) => page.classList.toggle('is-active', pageIndex === targetIndex));
        index = targetIndex;
        updateCount();
        return;
      }
      isTurning = true;
      const current = pages[index];
      const incoming = pages[targetIndex];
      const enteringClass = direction === 'back' ? 'is-entering-back' : 'is-entering-forward';
      const leavingClass = direction === 'back' ? 'is-leaving-back' : 'is-leaving-forward';
      if (previous) previous.disabled = true;
      if (next) next.disabled = true;
      current.classList.add(leavingClass);
      incoming.classList.add('is-active', enteringClass);
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => incoming.classList.remove(enteringClass)));
      window.setTimeout(() => {
        current.classList.remove('is-active', leavingClass);
        index = targetIndex;
        updateCount();
        if (previous) previous.disabled = false;
        if (next) next.disabled = false;
        isTurning = false;
      }, 700);
    };
    if (previous) previous.addEventListener('click', () => showPage(index - 1, 'back'));
    if (next) next.addEventListener('click', () => showPage(index + 1, 'forward'));
    viewer.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showPage(index - 1, 'back'); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showPage(index + 1, 'forward'); }
    });
  });
  document.querySelectorAll('[data-deed-language-selector]').forEach((selector) => {
    if (selector.dataset.currencyReady) return;
    selector.dataset.currencyReady = 'true';
    selector.addEventListener('change', () => {
      const countryInput = selector.form && selector.form.querySelector('[data-deed-language-country]');
      const option = selector.options[selector.selectedIndex];
      if (countryInput && option && option.dataset.countryCode) countryInput.value = option.dataset.countryCode;
      if (selector.form) selector.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
